module.exports = __webpack_public_path__ + "img/p2-8.549ea600.png";